export enum TaxTreatment {
  Default = 0,
  DIP = 1,
}
